export default __webpack_public_path__ + "static/media/our-programs-hero.fe15d229.png";